
/**
  * 以下这段代码是用于根据移动端设备的屏幕分辨率计算出合适的根元素的大小
  * 当设备宽度为375(iPhone6)时，根元素font-size=16px; 依次增大；
  * 限制当为设备宽度大于768(iPad)之后，font-size不再继续增大
  * scale 为meta viewport中的缩放大小
  */
 (function (doc, win) {
    const docEl = win.document.documentElement
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    /**
      * ================================================
      * 设置根元素font-size
      * 当设备宽度为375(iPhone6)时，根元素font-size=16px; 
      × ================================================
      */
     const refreshRem = function () {
        let clientWidth = win.innerWidth
            || doc.documentElement.clientWidth
            || doc.body.clientWidth
        // if(window.self !== window.top) {
        //   clientWidth =  window.top.getElementById("kufu").clientWidth 
        // }
      if (!clientWidth) return
      const width = clientWidth
      const fz = 100 * width / 750
      // docEl.style.fontSize = fz + 'px'
      if(clientWidth>=750){
        // docEl.style.fontSize = '100px';
      }else{
        docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
      }
    };
   
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, refreshRem, false)
    doc.addEventListener('DOMContentLoaded', refreshRem, false)
    refreshRem()
   
  })(document, window)


// WEBPACK FOOTER //
// ./src/utils/rem.js